import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createScreenerEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackScreenerOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.SCREENER_OPEN,
      properties: { source },
    });

  const trackScreenerCreate = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.SCREENER_CREATE,
      properties: { source },
    });

  const trackScreenerUpdate = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.SCREENER_UPDATE,
      properties: { source },
    });

  const trackScreenerTabSelected = (
    source: PosthogTrackingSource,
    type: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.SCREENER_TAB_SELECTED,
      properties: { source, type },
    });

  return {
    trackScreenerOpen,
    trackScreenerCreate,
    trackScreenerUpdate,
    trackScreenerTabSelected,
  };
};
